import { useState } from 'react';
import RaiseHelpRequestModal from './RaiseHelpRequestModal';
import { isHelpRequestEnabled } from '../utils/featureFlags';

function HelpButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Only show help button if enabled (auto-enabled in non-prod, disabled in prod)
  if (!isHelpRequestEnabled()) {
    return null;
  }

  return (
    <>
      {/* Floating Help Button */}
      <div className="fixed bottom-24 right-4 z-40 safe-bottom">
        <button
          onClick={() => setIsModalOpen(true)}
          className="relative flex items-center justify-center transition-all duration-300 active:scale-90"
          aria-label="Get Help"
        >
          {/* Subtle pulse ring */}
          <span className="absolute inset-0 rounded-full bg-orange-300/40 animate-ping"></span>
          
          {/* Astronaut PNG */}
          <img 
            src="/ASTRONAUT.png" 
            alt="Help" 
            className="relative w-16 h-16 animate-float drop-shadow-2xl"
          />
        </button>
      </div>

      {/* Help Request Modal */}
      <RaiseHelpRequestModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}

export default HelpButton;
